import api from "src/api";
import { insertCss } from "src/utils";
import { waitForMultiElm } from "../../utils/html";
class GoogleRecaptcha {
  constructor({
    reCaptchaScoreSiteKey,
    reCaptchaChallengeSiteKey,
    googleRecaptchaSampleRate,
    googleRecaptchaShowThreshold,
    googleRecaptchaSolveThreshold
  }) {
    if (GoogleRecaptcha._instance) {
      return GoogleRecaptcha._instance;
    }
    GoogleRecaptcha._instance = this;
    this.score = null;
    this.reCaptchaScoreSiteKey = reCaptchaScoreSiteKey || "6LdvW2smAAAAAAEFIHGKkV2oKse-QIV6mYSVb3sn";
    this.reCaptchaChallengeSiteKey = reCaptchaChallengeSiteKey || "6LdXUGUmAAAAAIzEuaM8Se_65G3_ldo9ygvFvYJc";
    this.googleRecaptchaSampleRate = googleRecaptchaSampleRate != undefined ? googleRecaptchaSampleRate : 100;
    this.googleRecaptchaShowThreshold = googleRecaptchaShowThreshold != undefined ? googleRecaptchaShowThreshold : 0.5;
    this.googleRecaptchaSolveThreshold = googleRecaptchaSolveThreshold != undefined ? googleRecaptchaSolveThreshold : 0.5;
    this.initRecaptcha();
  }

  async initRecaptcha() {
    try {
      const random = Math.random() * 100;
      if (random < this.googleRecaptchaSampleRate) {
        const script = document.getElementById("recaptcha");
        if (!script) await this.insertGoogleScript();
        const token = await this.getScoreTokenFromGoogle();
        const { riskAnalysis } = await this.getScoreForToken(token, "score");
        this.score = riskAnalysis.score;
      } else {
        this.score = 1;
      }
      await this.blockNewTab();
    } catch (error) {
      console.log(error);
    }
  }

  async initChallengeCaptcha(index, captchaParams) {
    try {
      if (!this.score) {
        await this.initRecaptcha();
      }
      // Added 0.001 to threshold to handle boundary case when score = 1 and threshold = 1, we want to show captcha in this case
      if (this.score < this.googleRecaptchaShowThreshold + 0.001) {
        const token = await this.showCaptcha(index, captchaParams);
        const { riskAnalysis } = await this.getScoreForToken(token, "challenge", captchaParams);
        if (riskAnalysis.score < this.googleRecaptchaSolveThreshold + 0.001) return true;
        else return false;
      } else {
        return false;
      }
    } catch (error) {
      console.log(error);
    }
  }

  insertGoogleScript() {
    return new Promise((resolve, reject) => {
      const head = document.getElementsByTagName("head")[0];
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.id = "recaptcha";
      script.src = `https://www.google.com/recaptcha/enterprise.js?render=${this.reCaptchaScoreSiteKey}`;
      script.onload = function() {
        resolve(script);
      };
      script.onerror = function() {
        reject(new Error("Load error"));
      };
      head.appendChild(script);
    });
  }

  getScoreTokenFromGoogle() {
    return new Promise(resolve => {
      window.grecaptcha.enterprise.ready(() => {
        window.grecaptcha.enterprise.execute(this.reCaptchaScoreSiteKey, { action: "click" }).then(function(token) {
          resolve(token);
        });
      });
    });
  }

  getScoreForToken(token, keyType, extraParams = {}) {
    const params = {
      token,
      keyType,
      siteKey: keyType === "challenge" ? this.reCaptchaChallengeSiteKey : this.reCaptchaScoreSiteKey,
      ...extraParams
    };

    return api.getRecaptchaScore(params);
  }

  showCaptcha(index, captchaParams) {
    return new Promise(resolve => {
      const verifyCallback = function(token) {
        resolve(token);
      };
      window.grecaptcha.enterprise.render(`recaptcha-${index}`, {
        sitekey: this.reCaptchaChallengeSiteKey,
        callback: verifyCallback
      });

      const cssCode = `
      #app {
        pointer-events:none;
      }

      div[data-name= "recaptcha"] {
        pointer-events:auto;
      }
      `;
      insertCss(cssCode);
      this.getScoreForToken("", "captchaShown", captchaParams);
    });
  }

  destroyDom() {
    const app = document.getElementById("app");
    const accessDenied = document.createElement("h1");
    accessDenied.innerText = "Access Denied";
    const noPermission = document.createElement("p");
    noPermission.innerText = "You don't have permission to access this page";
    const documentFragment = document.createDocumentFragment();
    documentFragment.appendChild(accessDenied);
    documentFragment.appendChild(noPermission);
    document.getElementsByTagName("body")[0].replaceChild(documentFragment, app);
  }

  async blockNewTab() {
    const links = await waitForMultiElm(".captcha-block-new-tab");

    links.forEach((ad) => {
      ad.addEventListener("contextmenu", event => event.preventDefault());
      ad.addEventListener("auxclick", e => {
        if (e.which == 2) {
          e.preventDefault();
          e.stopPropagation();
          e.target.click();
        }
        return true;
      });
    })

  }
}

export default GoogleRecaptcha;
